import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"
import UserSettingsViewsBoard from "./board"
import UserSettingsViewsMyCalendar from "./my-calendar"
import UserSettingsViewsMyWork from "./my-work/my-work"
import UserSettingsViewsTaskList from "./task-list"
import UserSettingsViewsGantt from "./gantt"
import UserSettingsViewsWorkload from "./workload"
import UserSettingsUsersManagement from "./users-management"
import UserSettingsViewsNotepad from "./notepad"
import UserSettingsViewsNotifications from "./notifications"
import UserSettingsViewsChat from "./chat"
import UserSettingsViewsGoals from "./goals"
import UserSettingsViewsSavedReports from "./saved-reports"
import UserSettingsViewsArchivedProjectsView from "./archived-projects-view"
import UserSettingsViewsCRMProjectsView from "./crm-projects-view"
import UserSettingsViewsTimeline from "./timeline"
import UserSettingsViewsMyTasks from "./my-tasks";
import UserSettingsViewsTodos from "./todos";
import UserSettingsViewsTaskView from "./task-view"
import UserSettingsViewsMyTime from "./my-time"
import UserSettingsViewsMyWork_Collection from "./my-work/collection";

const fieldsConfig = {

    notepad    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsNotepad
    },
    chat    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsChat
    },
    taskView    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsTaskView
    },

    myTime    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsMyTime
    },

    board: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsBoard,
    },

    myWork: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsMyWork
    },

    myTasks: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsMyTasks
    },

    notifications: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsNotifications
    },

    myCalendar: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsMyCalendar,
    },

    taskList: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsTaskList
    },

    gantt: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsGantt
    },

    workload: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsWorkload
    },

    timeline: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsTimeline
    },

    usersManagement: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsUsersManagement
    },

    autoSave  : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : true
    },

    goals    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsGoals
    },

    rightClickMoreMenu  : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : true
    },

    savedReports    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsSavedReports
    },

    crmProjects     : {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsCRMProjectsView
    },

    archivedProjects: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsArchivedProjectsView
    },

    todos: {
        type            : ServerSettingsFieldType.CLASS,
        class           : UserSettingsViewsTodos,
    },
}

export default class UserSettingsViews extends ServerSettings {

    public board                : UserSettingsViewsBoard
    public notepad              : UserSettingsViewsNotepad
    public chat                 : UserSettingsViewsChat
    // public myWork               : UserSettingsViewsMyWork
    public myWork               : UserSettingsViewsMyWork_Collection
    public myTasks              : UserSettingsViewsMyTasks
    public notifications        : UserSettingsViewsNotifications
    public myCalendar           : UserSettingsViewsMyCalendar
    public taskList             : UserSettingsViewsTaskList
    public gantt                : any
    public workload             : any
    public timeline             : UserSettingsViewsTimeline
    public usersManagement      : any
    public autoSave             : any   // boolean ???
    public taskView             : UserSettingsViewsTaskView
    public myTime               : UserSettingsViewsMyTime
    public goals                : UserSettingsViewsGoals
    public rightClickMoreMenu   : boolean
    public savedReports         : UserSettingsViewsSavedReports
    public crmProjects          : UserSettingsViewsCRMProjectsView
    public archivedProjects     : UserSettingsViewsArchivedProjectsView
    public todos                : UserSettingsViewsTodos

    constructor(config: any) {

        super(config, fieldsConfig);

        this.notepad            = this.initValue('notepad')
        this.chat               = this.initValue('chat')
        this.taskView           = this.initValue('taskView')
        this.board              = this.initValue('board')
        // this.myWork             = this.initValue('myWork')

        // Raw json, per company models are created by syncCompanies() on companies reset
        this.myWork             = UserSettingsViewsMyWork_Collection.initFromJson(this._getValue('myWork'))
        // this.myWork.syncCompanies() // In case companies are already loaded

        this.myTasks            = this.initValue('myTasks')
        this.notifications      = this.initValue('notifications')
        this.myCalendar         = this.initValue('myCalendar')
        this.taskList           = this.initValue('taskList')
        this.gantt              = this.initValue('gantt')
        this.workload           = this.initValue('workload')
        this.timeline           = this.initValue('timeline')
        this.usersManagement    = this.initValue('usersManagement')
        this.myTime             = this.initValue('myTime')
        this.goals              = this.initValue('goals')

        // auto save current views when change
        this.autoSave           = this.initValue('autoSave')

        // Table/List/Board/Gantt item right click show more menu
        this.rightClickMoreMenu = this.initValue('rightClickMoreMenu')

        this.savedReports       = this.initValue('savedReports')
        this.crmProjects        = this.initValue('crmProjects')
        this.archivedProjects   = this.initValue('archivedProjects')
        this.todos              = this.initValue('todos')
    }

    toJson() {

        const result = {};

        this.valueToJson(result, 'myTime')
        this.valueToJson(result, 'notepad')
        this.valueToJson(result, 'chat')
        this.valueToJson(result, 'taskView')
        this.valueToJson(result, 'board')
        this.valueToJson(result, 'myWork')
        this.valueToJson(result, 'myTasks')
        this.valueToJson(result, 'notifications')
        this.valueToJson(result, 'myCalendar')
        this.valueToJson(result, 'taskList')
        this.valueToJson(result, 'gantt')
        this.valueToJson(result, 'workload')
        this.valueToJson(result, 'timeline')
        this.valueToJson(result, 'usersManagement')
        this.valueToJson(result, 'autoSave')
        this.valueToJson(result, 'goals')
        this.valueToJson(result, 'rightClickMoreMenu')
        this.valueToJson(result, 'savedReports')
        this.valueToJson(result, 'crmProjects')
        this.valueToJson(result, 'archivedProjects')
        this.valueToJson(result, 'todos')

        return result;
    }
}
